/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type chat_viewer$ref: FragmentReference;
export type chat_viewer = {|
  +vipChatEmail: ?$ReadOnlyArray<?{|
    +userDataB: ?$ReadOnlyArray<?{|
      +email?: ?string
    |}>
  |}>,
  +tradeChatEmail: ?$ReadOnlyArray<?{|
    +userDataB: ?$ReadOnlyArray<?{|
      +email?: ?string
    |}>
  |}>,
  +allTransactions: ?{|
    +totalResults: ?number
  |},
  +initiatedTransactions: ?{|
    +totalResults: ?number
  |},
  +submittedTransactions: ?{|
    +totalResults: ?number
  |},
  +confirmedTransactions: ?{|
    +totalResults: ?number
  |},
  +$refType: chat_viewer$ref,
|};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "kind": "Variable",
  "name": "userIds",
  "variableName": "userIds",
  "type": "[String]!"
},
v1 = [
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "email",
    "args": null,
    "storageKey": null
  }
],
v2 = {
  "kind": "Variable",
  "name": "buyerId",
  "variableName": "userIds",
  "type": "[String]"
},
v3 = {
  "kind": "Literal",
  "name": "first",
  "value": 0,
  "type": "Int"
},
v4 = [
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "totalResults",
    "args": null,
    "storageKey": null
  }
];
return {
  "kind": "Fragment",
  "name": "chat_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "userIds",
      "type": "[String]!"
    }
  ],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": "vipChatEmail",
      "name": "userRelationships",
      "storageKey": null,
      "args": [
        {
          "kind": "Literal",
          "name": "relationshipType",
          "value": "VIP",
          "type": "relationshipType!"
        },
        (v0/*: any*/)
      ],
      "concreteType": "UserRelationship",
      "plural": true,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "userDataB",
          "storageKey": null,
          "args": null,
          "concreteType": null,
          "plural": true,
          "selections": [
            {
              "kind": "InlineFragment",
              "type": "VipRepData",
              "selections": (v1/*: any*/)
            }
          ]
        }
      ]
    },
    {
      "kind": "LinkedField",
      "alias": "tradeChatEmail",
      "name": "userRelationships",
      "storageKey": null,
      "args": [
        {
          "kind": "Literal",
          "name": "relationshipType",
          "value": "TRADE",
          "type": "relationshipType!"
        },
        (v0/*: any*/)
      ],
      "concreteType": "UserRelationship",
      "plural": true,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "userDataB",
          "storageKey": null,
          "args": null,
          "concreteType": null,
          "plural": true,
          "selections": [
            {
              "kind": "InlineFragment",
              "type": "TradeRepData",
              "selections": (v1/*: any*/)
            }
          ]
        }
      ]
    },
    {
      "kind": "LinkedField",
      "alias": "allTransactions",
      "name": "transactions",
      "storageKey": null,
      "args": [
        (v2/*: any*/),
        (v3/*: any*/)
      ],
      "concreteType": "TransactionConnection",
      "plural": false,
      "selections": (v4/*: any*/)
    },
    {
      "kind": "LinkedField",
      "alias": "initiatedTransactions",
      "name": "transactions",
      "storageKey": null,
      "args": [
        (v2/*: any*/),
        (v3/*: any*/),
        {
          "kind": "Literal",
          "name": "viewName",
          "value": "buyerTracking.initiated",
          "type": "String"
        }
      ],
      "concreteType": "TransactionConnection",
      "plural": false,
      "selections": (v4/*: any*/)
    },
    {
      "kind": "LinkedField",
      "alias": "submittedTransactions",
      "name": "transactions",
      "storageKey": null,
      "args": [
        (v2/*: any*/),
        (v3/*: any*/),
        {
          "kind": "Literal",
          "name": "viewName",
          "value": "buyerTracking.submitted",
          "type": "String"
        }
      ],
      "concreteType": "TransactionConnection",
      "plural": false,
      "selections": (v4/*: any*/)
    },
    {
      "kind": "LinkedField",
      "alias": "confirmedTransactions",
      "name": "transactions",
      "storageKey": null,
      "args": [
        (v2/*: any*/),
        (v3/*: any*/),
        {
          "kind": "Literal",
          "name": "sort",
          "value": "createdDate asc",
          "type": "String"
        },
        {
          "kind": "Literal",
          "name": "viewName",
          "value": "buyerTracking.confirmed",
          "type": "String"
        }
      ],
      "concreteType": "TransactionConnection",
      "plural": false,
      "selections": (v4/*: any*/)
    }
  ]
};
})();
// prettier-ignore
(node/*: any*/).hash = 'b6f7241498eb48f30528a3ef27a80459';
module.exports = node;
